const XiaomiLayout = ({ children }) => (
  <div class="page">
    <div class="page-main">
      <div class="my-3 my-md-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">{children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default XiaomiLayout;
